<template>
  <div style="padding: 0 15px;" class="mall-home" >
    <router-link style="color: black" class="f messages" to="/web-index"  >
    <span class="icon font_family icon-dibutubiao_shouye" style="font-size: 20px;"></span>
      <span  style="font-size: 15px;" >商城首页</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',

  methods: {

  }
}
</script>

<style scoped>
.mall-home {
  display: inline-block;
  vertical-align: middle;
  width: 200px;
  height: 40px;
  line-height: 10px;
}

.mall-home.is-active {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/comm/MallHome/index.vue